export default "__VITE_ASSET__BfHXslgH__"